import { IServiceWorker } from '@monofe/worker/interface/worker';
import { IContainer, ILazyBinder, injectContainer } from './container';

const TYPES = {
    IServiceWorker: Symbol.for('IServiceWorker'),
};

export function injectServiceWorker(
    container: IContainer = injectContainer(),
): Promise<IServiceWorker> {
    return container.get<ILazyBinder<IServiceWorker>>(TYPES.IServiceWorker)();
}

export function bindServiceWorker(
    binder: ILazyBinder<IServiceWorker>,
    container: IContainer = injectContainer(),
) {
    container.bind<ILazyBinder<IServiceWorker>>(TYPES.IServiceWorker, binder);
}
